import { render } from "./UpdateRenewalDataModal.vue?vue&type=template&id=221e22d8"
import script from "./UpdateRenewalDataModal.vue?vue&type=script&lang=js"
export * from "./UpdateRenewalDataModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__